import { usePost } from "./useCall";

const usePostUserKeycloakRoles = () => usePost("/users/keycloak-roles");
export default usePostUserKeycloakRoles;
